// eslint-disable-next-line import/no-cycle
import { APIS, clients } from '@/core/clients';

const client = clients[APIS.SELF_SERVICE.name];
const reportingApi = {
  getPublisherIdsWithStats(payload) {
    return client.get(`/stats/publishers?creativeIds=${payload.creativeIds}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getContentDailyStats(payload) {
    return client.post(`/stats/a/${payload.advertiserId}/stats/advertiser-content`, payload.body)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getOverallCreativeCampaignStats(payload) {
    return client.post(`/stats/a/${payload.advertiserId}/creatives/stats`, payload.body)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  downloadReportAsCSV(payload) {
    return client.post('/stats/generate/csv-report', payload)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
};
export default reportingApi;
